import { useHistory } from 'react-router-dom';
import { IUseModalWelcomeAi } from '../types';

const useModalWelcomeAi = ({ onClose }: IUseModalWelcomeAi) => {
  const navigate = useHistory();
  const handleNavigateGreenfyAi = () => {
    onClose();
    navigate.push('/greenfy-ai');
  };
  return { handleNavigateGreenfyAi };
};

export default useModalWelcomeAi;
